/* Results Media pages for Cyclone: add to cart, variant picker, gallery, sticky bar, video.
   Buttons use data-rm-atc (not data-dd-atc) so the theme's dd-atc.js never adds the same item twice.
   data-rm-atc="add" adds and lets UpCart open its drawer; "checkout" goes straight to checkout. */
(function () {
  if (window.rmBound) return;
  window.rmBound = true;

  var routes = (window.Shopify && Shopify.routes) || {};
  var root = routes.root || '/';
  var addUrl = (routes.cart_add_url || root + 'cart/add') + '.js';
  var cartUrl = routes.cart_url || root + 'cart';

  function hasDrawer() {
    return document.body && document.body.getAttribute('data-upcart-cart-enabled') === 'true';
  }

  function reset(btn) {
    btn.removeAttribute('aria-busy');
    if (btn.rmLabel != null) btn.innerHTML = btn.rmLabel;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-rm-atc]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var mode = btn.getAttribute('data-rm-atc');

    btn.rmLabel = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = mode === 'checkout' ? 'Loading…' : 'Adding…';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed ' + res.status);
        return res.json();
      })
      .then(function () {
        if (mode === 'checkout') { window.location.href = root + 'checkout'; return; }
        // UpCart watches fetch() calls to /cart/add and opens its drawer itself.
        if (!hasDrawer()) { window.location.href = cartUrl; return; }
        reset(btn);
      })
      .catch(function (err) {
        console.error('rm-atc:', err);
        reset(btn);
        // Fall back to a normal form post so the shopper still reaches the cart.
        if (btn.form) btn.form.submit();
      });
  });

  // Back from checkout restores the page from bfcache with the button still on "Loading…".
  window.addEventListener('pageshow', function (evt) {
    if (!evt.persisted) return;
    document.querySelectorAll('[data-rm-atc][aria-busy="true"]').forEach(reset);
  });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Variant picker: swaps the variant on every button for this product, the price and Shop Pay.
    var data = document.getElementById('rm-variants');
    if (data) {
      var variants = JSON.parse(data.textContent);
      document.querySelectorAll('input[name="rm-variant"]').forEach(function (input) {
        input.addEventListener('change', function () {
          var v = variants.filter(function (x) { return String(x.id) === input.value; })[0];
          if (!v) return;
          document.querySelectorAll('[data-rm-current]').forEach(function (btn) {
            btn.setAttribute('data-variant-id', v.id);
            var formId = btn.form && btn.form.querySelector('input[name="id"]');
            if (formId) formId.value = v.id;
            btn.disabled = !v.available;
            btn.innerHTML = v.available ? btn.getAttribute('data-label').replace('[price]', v.price) : 'Sold out';
          });
          document.querySelectorAll('[data-rm-price]').forEach(function (el) { el.textContent = v.price; });
          document.querySelectorAll('[data-rm-compare]').forEach(function (el) {
            el.textContent = v.compare || '';
            el.hidden = !v.compare;
          });
          document.querySelectorAll('[data-rm-save]').forEach(function (el) {
            el.textContent = v.save ? 'Save ' + v.save : '';
            el.hidden = !v.save;
          });
          var idInput = document.querySelector('#rm-pt-form input[name="id"]');
          if (idInput) {
            idInput.value = v.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    // Gallery: thumbnails scroll the swipeable track, and the track marks the current thumbnail.
    var track = document.querySelector('.rm-track');
    var thumbs = document.querySelectorAll('.rm-thumb');
    if (track && thumbs.length) {
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        }, 60);
      });
    }

    // Sticky buy bar shows once the main buy button has scrolled up out of view.
    // A scroll check rather than IntersectionObserver: a fast fling can jump the button
    // from below the fold to above it without ever firing an intersection change.
    var bar = document.querySelector('.rm-sticky');
    var cta = document.querySelector('[data-rm-sticky-anchor]');
    if (bar && cta) {
      var pending = false;
      var update = function () {
        pending = false;
        bar.classList.toggle('is-shown', cta.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (!pending) { pending = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    } else if (bar) {
      bar.classList.add('is-shown');
    }

    // Video: swap the poster for the YouTube player on click.
    document.querySelectorAll('[data-rm-yt]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + a.getAttribute('data-rm-yt') + '?autoplay=1&rel=0';
        f.title = 'Cyclone QuickStart video';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.className = 'rm-video-frame';
        a.replaceWith(f);
      });
    });
  });
})();
